import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { get, forEach, map } from 'lodash';

import SelectControl from '../../../../../../components/SelectControl';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import OptionButton from '../OptionButton';
import { isRequired } from '../../../../../../util/validators';

interface IItem {
    name: string;
    key: string;
}

interface IOptionsListProps {
    optionsMap: { [fieldKey: string]: any };
    localOptions: { [key: string]: boolean };
    quote: any;
    isCalculating: boolean;
    showPartCMessageModal: boolean;
    renderDefinition: (name: string, defName?: string, icon?: string) => any;
    recalculatePrice: () => void;
    onToggleBooleanOption: (optionKey: string) => void;
    renderPartCMessageModal: () => any;
    channelKey: string;
}

export default class OptionsList extends React.PureComponent<IOptionsListProps> {
    private shouldExcludeWinterSports = () => {
        const quote = this.props.quote;
        let excludeWinter = false;

        const travellers = get(quote, 'application.travellers', []);
        forEach(travellers, (traveller) => {
            if (get(traveller, 'screening.meta.hasWinterSportsExclusion')) {
                excludeWinter = true;
            }
        });

        return excludeWinter;
    }

    private handleToggleBooleanOption = (fieldKey: string) => () => {
        this.props.onToggleBooleanOption(fieldKey);
    }

    private getAutoIncludedBooleanKeys = () => {
        const list: string[] = [];
        const optionsMap = this.props.optionsMap;

        if (!optionsMap) { return list; }

        forEach(optionsMap, (opt, fieldKey) => {
            if (opt && opt.auto_include === true && opt.input_type !== 'enum') {
                list.push(fieldKey);
            }
        });

        return list;
    }

    private renderListOption = (option: any, fieldKey: string) => {
        const quote = this.props.quote;
        const renderDefinition = this.props.renderDefinition;

        const pack = get(quote, 'application.options.hazardous_activities', 'pack1');

        const list = map(option.options, (item: IItem) => {
            return {
                label: item.name,
                value: item.key,
            };
        });

        return (
            <div key={fieldKey} className="options-section">
                <Row>
                    <Col md={12} lg={6}>
                        <div className="question-text">
                            <div className="title">
                                <div>
                                    {option.name} {renderDefinition(fieldKey)} {renderDefinition(pack, pack)}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <Field
                            name={'options.' + fieldKey}
                            type="select"
                            options={list}
                            component={SelectControl}
                            clearable={false}
                            validate={[isRequired]}
                            onChange={this.props.recalculatePrice}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    private renderQuestionOption = (option: any, fieldKey: string) => {
        const renderDefinition = this.props.renderDefinition;
        const localOptions = this.props.localOptions;
        const isSelected = !!localOptions[fieldKey];

        const autoIncludedKeys = this.getAutoIncludedBooleanKeys();
        const isAutoIncluded = autoIncludedKeys.indexOf(fieldKey) !== -1;
        const channelKey = this.props.channelKey;

        if (isAutoIncluded) {
            return (
                <div key={fieldKey}>
                    <div className="options-section">
                        <Row>
                            <Col sm={8}>
                                <div className="question-text">
                                    <div className="title">
                                        {option.name} {renderDefinition(fieldKey)}
                                    </div>
                                </div>
                            </Col>
                            <Col sm={4} className="option-question-disabled">
                                <Field
                                    name={'options.' + fieldKey}
                                    type="checkbox"
                                    value={true}
                                    complexValue={false}
                                    className="answer"
                                    component={FieldFormControl}
                                    disabled={true}
                                >
                                    <div className="option-btn included">
                                        <div className="option-content">
                                            <span className="auto-included">Included</span>
                                        </div>
                                    </div>
                                </Field>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }

        return (
            <div key={fieldKey}>
                <div className="options-section">
                    <Row>
                        <Col sm={8}>
                            <div className="question-text">
                                <div className="title">
                                    {option.name} {renderDefinition(fieldKey)}
                                </div>
                            </div>
                        </Col>
                        <Col sm={4} className="option-question">
                            <OptionButton
                                disabled={!!this.props.isCalculating}
                                isSelected={isSelected}
                                selectedText="Remove"
                                unselectedText="Upgrade Cover"
                                onClick={this.handleToggleBooleanOption(fieldKey)}
                                channelKey={channelKey}
                            />
                        </Col>
                    </Row>
                </div>

                {this.props.renderPartCMessageModal()}
            </div>
        );
    }

    private renderOption = (option: any, fieldKey: string) => {
        if (!option) { return null; }

        const excludeWinter = this.shouldExcludeWinterSports();
        if (option.name === 'Winter Sports' && excludeWinter) {
            return null;
        }

        switch (option.input_type) {
            case 'enum':
                return this.renderListOption(option, fieldKey);
            case 'boolean':
                return this.renderQuestionOption(option, fieldKey);
            default:
                return null;
        }
    }

    public render() {
        const optionsMap = this.props.optionsMap;

        if (!optionsMap) { return null; }

        return (
            <div>
                {map(optionsMap, (option: any, fieldKey: string) => {
                    return this.renderOption(option, fieldKey);
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/components/OptionsList/index.tsx